import { StoreInfo } from '../../../Component/Interface/Store';

// These are editable starting points. Loading one never saves or publishes it.
export function customerPolicyDraft(type: 'terms' | 'privacy', store: Partial<StoreInfo>): string {
  const name = store.com_name?.trim() || store.store_name?.trim() || '[상호 입력]';
  const contact = `전화: ${store.store_phone?.trim() || '[연락처 입력]'} / 이메일: ${store.store_email?.trim() || '[이메일 입력]'}`;
  const address = [store.addr_basic, store.addr_detail].filter(Boolean).join(' ') || '[사업장 주소 입력]';
  const business = `상호: ${name}
대표자: ${store.rep_name?.trim() || '[대표자 입력]'}
사업자등록번호: ${store.business_reg_number?.trim() || '[사업자등록번호 입력]'}
사업장 주소: ${address}
${contact}`;

  if (type === 'terms') return `${name} 구매자 이용약관

제1조 (목적 및 적용 범위)
이 약관은 ${name}(이하 "판매자")이 팬버드에서 판매하는 상품의 구매, 배송, 교환·반품·환불에 관한 판매자와 구매자 사이의 권리와 의무를 정합니다. 팬버드 회원가입, 계정 및 플랫폼 서비스 이용에는 기역기역 주식회사의 팬버드 회원 이용약관이 함께 적용됩니다.

제2조 (판매자 정보 및 문의)
${business}
구매자는 팬버드의 주문 문의 또는 위 연락처로 거래 관련 문의를 할 수 있습니다.

제3조 (상품 정보 및 주문)
① 판매자는 상품의 내용, 가격, 배송비, 결제수단, 배송 예정일, 교환·반품 조건을 주문 전에 확인할 수 있도록 안내합니다.
② 구매자는 주문 내용을 확인·정정한 후 주문하며, 판매자가 주문을 승낙하면 매매계약이 성립합니다.
③ 품절 등으로 상품을 공급할 수 없는 경우 판매자는 구매자에게 알리고 관련 법령에 따라 취소 및 환급을 처리합니다.

제4조 (결제)
① 이용 가능한 결제수단과 입금기한은 실제 주문화면에 표시된 내용을 따릅니다.
② PG결제는 팬버드에서 제공하는 결제창을 통해 진행합니다. 무통장 입금은 주문화면에 표시된 계좌와 금액을 확인하여 입금합니다.
③ 입금기한 경과, 미입금 또는 주문 취소에 관한 사항은 주문 시 안내된 조건과 팬버드 회원 이용약관 및 관련 법령에 따릅니다.

제5조 (배송)
① 배송비, 합배송·개별배송 여부 및 발송 예정일은 상품 또는 주문화면에 안내된 조건을 따릅니다.
② 별도로 약정한 공급시기가 없다면 판매자는 관련 법령에서 정한 기간 내에 공급에 필요한 조치를 하며, 지연이 예상되는 경우 사유와 일정을 알립니다.
③ 구매자는 정확한 수령인 정보와 배송지를 입력해야 하며, 정보 변경이 필요한 경우 발송 전에 판매자에게 문의합니다.

제6조 (청약철회 및 교환·반품)
① 구매자는 계약서면을 받은 날부터 7일 이내에 청약철회를 할 수 있습니다. 상품을 더 늦게 공급받은 경우에는 상품을 공급받은 날부터 7일 이내에 할 수 있습니다.
② 상품이 표시·광고 내용 또는 계약 내용과 다르게 이행된 경우에는 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회를 할 수 있습니다.
③ 사용·훼손, 가치의 현저한 감소, 주문 제작 등 청약철회 제한 사유는 관련 법령에서 정한 요건과 사전 고지·동의 요건을 충족한 범위에서만 적용합니다. 내용 확인을 위한 포장 훼손만으로 반품을 제한하지 않습니다.
④ 단순 변심에 따른 반환 비용은 구매자가, 하자·오배송 등 판매자 사유에 따른 비용은 판매자가 부담합니다. 구체적인 반품비와 반품 주소는 주문 전 안내 및 반품 접수 시 확인할 수 있습니다.
⑤ 교환·반품은 팬버드 주문 문의 또는 제2조 연락처로 신청할 수 있습니다. 라이브 상품, 할인 상품이라는 이유만으로 법령상 청약철회 권리를 제한하지 않습니다.

제7조 (환급)
① 판매자는 반환받은 상품을 확인하고, 상품을 반환받은 날부터 3영업일 이내에 대금을 환급합니다. 공급 전 취소 등은 관련 법령에서 정한 환급기한에 따릅니다.
② PG결제는 원 결제수단의 취소·환불 절차에 따르며, 계좌 환불이 필요한 경우 환불 처리에 필요한 최소한의 계좌정보를 요청할 수 있습니다.
③ 환급이 지연되는 경우 관련 법령에 따른 지연배상금을 지급합니다.

제8조 (개인정보 및 분쟁 처리)
① 판매자는 주문 처리에 필요한 개인정보를 구매자 개인정보처리방침에 따라 처리하며, 별도 동의 없이 외부 홍보나 개인 연락에 사용하지 않습니다.
② 판매자는 구매자의 불만과 분쟁을 신속히 처리하며, 해결되지 않은 분쟁은 관계기관의 분쟁조정 또는 법령에서 정한 관할법원에서 해결할 수 있습니다.
③ 이 약관에 정하지 않은 사항은 팬버드 회원 이용약관 및 관련 법령을 따르며, 법령에 반하여 구매자의 권리를 제한하는 조건은 적용하지 않습니다.`;

  return `${name} 구매자 개인정보처리방침

${name}(이하 "판매자")는 팬버드에서 이루어지는 상품 거래와 관련하여 제공받거나 수집하는 구매자의 개인정보를 다음과 같이 처리합니다. 팬버드 회원가입·계정·플랫폼 이용에 관한 개인정보 처리는 기역기역 주식회사의 팬버드 회원 개인정보처리방침을 함께 확인해 주세요.

제1조 (처리 목적, 항목 및 보유기간)
판매자는 주문 이행에 필요한 최소한의 정보를 팬버드를 통하거나 구매자의 직접 문의 과정에서 제공받습니다. 거래 이행은 계약 이행, 법정 기록 보관은 법령상 의무에 근거합니다.
| 처리 목적 | 처리 항목 | 보유기간 |
| --- | --- | --- |
| 주문 확인 및 상품 배송 | 주문자·수령인 이름, 연락처, 배송지, 주문내역, 배송 요청사항 | 거래 완료 후 법정 보존기간까지. 불필요한 배송 요청정보는 목적 달성 후 파기 |
| 교환·반품·환불 | 주문정보, 연락처, 반품·환불 신청 내용, 계좌 환불 시 은행명·계좌번호·예금주명 | 처리 완료 후 법정 보존기간까지 |
| 고객상담 및 분쟁 처리 | 상담 내용, 연락처, 관련 주문정보 | 처리 완료 후 3년 |
판매자는 주문하지 않은 팔로워의 연락처를 수집하거나 제공받지 않으며, 주문정보를 별도 동의 없이 광고·외부 채널 홍보에 사용하지 않습니다.

제2조 (법령에 따른 보존)
| 보존 항목 | 기간 | 근거 법령 |
| --- | --- | --- |
| 계약 또는 청약철회에 관한 기록 | 5년 | 전자상거래법 |
| 대금결제 및 재화 등의 공급에 관한 기록 | 5년 | 전자상거래법 |
| 소비자 불만 또는 분쟁처리에 관한 기록 | 3년 | 전자상거래법 |
| 표시·광고에 관한 기록 | 6개월 | 전자상거래법 |
법정 보존 대상은 목적별로 분리하여 보관하며 보존기간이 끝나면 파기합니다.

제3조 (제3자 제공 및 처리업무 위탁)
① 판매자는 정보주체의 동의나 법령상 근거가 있는 경우에만 개인정보를 제3자에게 제공합니다.
② 상품 배송 등 처리업무를 위탁하는 경우 실제 계약한 수탁자와 업무를 아래에 공개하며, 목적 외 처리 금지와 안전한 처리를 관리·감독합니다.
| 수탁자 | 위탁 업무 |
| --- | --- |
| [실제 이용하는 택배사명 입력] | 상품 배송 및 반품 수거 |
[추가 배송·물류 수탁자가 있으면 업체명과 업무를 기재하고, 없으면 이 안내를 삭제해 주세요.]
③ 팬버드 운영과 본사 PG결제에 관한 처리업체 및 국외 이전 여부는 팬버드 회원 개인정보처리방침에서 확인할 수 있습니다. 판매자가 별도로 사용하는 업체나 국외 이전이 있는 경우에는 실제 처리내용과 법적 근거를 이 방침에 추가하여 공개합니다.

제4조 (파기 및 안전성 확보)
① 목적 달성 또는 보유기간 경과 시 개인정보를 지체 없이 파기합니다. 전자파일은 복구할 수 없도록 삭제하고 종이 문서는 분쇄 또는 소각합니다.
② 판매자는 주문정보 접근권한 최소화, 계정 관리, 접근통제, 안전한 보관·전송 및 개인정보취급자 교육 등 필요한 안전조치를 이행합니다.
③ 다운로드한 주문정보도 같은 목적과 기간 내에서 관리하며, 별도 마케팅 목록으로 전용하지 않습니다.

제5조 (정보주체의 권리)
구매자는 개인정보 열람, 정정·삭제, 처리정지 및 동의 철회를 제6조 연락처로 요청할 수 있습니다. 판매자는 본인 확인 후 지체 없이 처리하고 결과를 알립니다. 법령상 보존의무 등으로 요구를 이행할 수 없는 경우에는 그 근거와 사유를 알립니다.

제6조 (개인정보 보호 문의)
개인정보처리자: ${name}
개인정보 보호책임자: [실제 지정한 성명·직위 입력]
${contact}
주소: ${address}
팬버드 계정과 플랫폼 이용정보에 관한 문의는 팬버드 회원 개인정보처리방침의 본사 연락처로 할 수 있습니다.

제7조 (처리방침의 변경)
판매자는 개인정보 처리내용이 변경되면 변경 사유와 시행일을 구매자가 확인할 수 있도록 공개하며, 동의가 필요한 변경은 별도 동의를 받습니다.`;
}
